import style from './EventCalendarToday.scss'
import in_array from 'locutus/php/array/in_array'
import { EventList } from '../../includes/EventList'
import date from 'locutus/php/datetime/date'
import classnames from 'classnames'

export default class EventCalendarToday extends React.Component {
  constructor() {
    super()

    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    const storedData = this.props.eventCalendar

    let active = false
    //initial
    if (storedData && (this.props.controller.active_dayitems.size === 0) && (in_array(this.props.day, storedData.dates_has_events) === true)) {
      active = true
    }

    let classes = classnames({
      'm-eventcalender__today': true,
      'has_events': (storedData && in_array(this.props.day, storedData.dates_has_events) === true),
      'active': (active === true)
    });

    return (
      <div class={classes}>
        <div class="m-eventcalender__todayinner">
          <a href={"#"} onClick={this.handleClick}>Heute</a>
        </div>
      </div>
    );
  }

  handleClick(e) {
    e.preventDefault()

    //clear
    document.querySelectorAll('.m-eventcalender__dayitem').forEach(item => {
      item.classList.remove(window.main.is_active_class)
    });

    //mark first calendar item
    this.props.controller.active_dayitems = new Map()

    let element = e.target.closest('.m-eventcalender__today');
    element.classList.add(window.main.is_active_class);

    if (element.classList.contains(window.main.is_active_class)) {
      //draw calender in inital offset
      this.props.controller.calender(this.props.controller.offset_init)

      this.props.controller.calculate_list_and_render(this.props.dayraw)
    }

    return false
  }
}
